<div class="truncate leading-5 text-subtitle flex gap-2 items-center">
  @if (item().metadata.date_pin) {
    <svg-icon class="flex h-5 w-5 text-base-status-warning" [src]="'icon-important-fill' | icon"></svg-icon>
  }
  @for (label of data(); track $index) {
    {{ label }}
    @if (!$last) {
      <svg-icon class="flex h-1 w-1 text-subtitle" [src]="'icon-ellipse' | icon"></svg-icon>
    }
  }
</div>
